import useTlmCart from '~/composable/useTlmCart';
import useCartQueries from '~/composable/useCartQueries';

export default function useCheckoutInfo (appContext) {
  const hubbleClient = appContext.$hubble;
  if (!appContext || !hubbleClient) {
    throw new Error('You must provide the nuxt app context to use this composable');
  }
  const { getCartID, subscriptionList, updateCart, cart } = useTlmCart(appContext);
  const { getDeviceWithInstallment } = useCartQueries(appContext, cart);
  const addNumberInfo = async (numberInfoDTO) => {
    const res = await hubbleClient.checkout.addNumberInfo(getCartID.value, numberInfoDTO, {
      cartID: getCartID.value,
      sku: subscriptionList.value.sku,
      groupID: subscriptionList.value.cartItemGroupID
    });
    updateCart(res.data.responseObject);
    return res;
  }
  const addPermissionInformation = async (permissionInformation) => {
    const actionResponse =
      await hubbleClient.checkout.addPermissionInformation(permissionInformation, getCartID.value, subscriptionList.value.cartItemGroupID, subscriptionList.value.sku)
    updateCart(actionResponse.data.responseObject);
    return actionResponse;
  }
  const removeInstallmentFromCart = async () => {
    const cartItemGroupUpdate = {
      cartID: cart.value.id,
      sku: getDeviceWithInstallment.value.sku,
      groupID: getDeviceWithInstallment.value.cartItemGroupID
    }

    const res = await hubbleClient.checkout.removeInstallments(cartItemGroupUpdate);
    updateCart(res.data.responseObject);
    return res
  }
  const addChangeSubscriptionCustomerInfo = async (prepaidAccountID, serviceAccountID) => {
    if (!prepaidAccountID || !serviceAccountID) {
      throw new Error('You must provide prepaidAccountID, serviceAccountID')
    }
    const cartItemGroupUpdate = {
      cartID: cart.value.id,
      sku: subscriptionList.value.sku,
      groupID: subscriptionList.value.cartItemGroupID,
      customFieldValue: [
        {
          name: 'PrepaidAccountId',
          value: prepaidAccountID
        },
        {
          name: 'ServiceAccountId',
          value: serviceAccountID
        }]

    }

    const res = await hubbleClient.checkout.addCustomerChangeSubscriptionInfo(cartItemGroupUpdate);
    updateCart(res.data.responseObject);
    return res
  }
  const removeChangeSubscriptionCustomerInfo = async () => {
    const cartItemGroupUpdate = {
      cartID: cart.value.id,
      sku: subscriptionList.value.sku,
      groupID: subscriptionList.value.cartItemGroupID
    }

    const res = await hubbleClient.checkout.removeCustomerChangeSubscriptionInfo(cartItemGroupUpdate);
    updateCart(res.data.responseObject);
    return res
  }
  const removeNumberInfo = async () => {
    const cartItemGroupUpdate = {
      cartID: cart.value.id,
      sku: subscriptionList.value.sku,
      groupID: subscriptionList.value.cartItemGroupID
    }

    const res = await hubbleClient.checkout.removeNumberInfo(cartItemGroupUpdate);
    updateCart(res.data.responseObject);
    return res
  }

  const addPhoneNumberToAddress = async (phoneNumber) => {
    const res = await hubbleClient.checkout.addPhoneNumberToAddress(
      cart.value.id,
      phoneNumber
    );
    updateCart(res.data.responseObject);
    return res
  }

  const addPhoneNumberAndEmailToAddress = async (phoneNumber, email) => {
    const res = await hubbleClient.checkout.addPhoneNumberAndEmailToAddress(
      cart.value.id,
      phoneNumber,
      email
    );
    updateCart(res.data.responseObject);
    return res
  }

  const addPrepaidEmail = async (emailAddress) => {
    const res = await hubbleClient.checkout.addPrePaidEmail(getCartID.value, emailAddress, {
      cartID: getCartID.value,
      sku: subscriptionList.value.sku,
      groupID: subscriptionList.value.cartItemGroupID
    });
    updateCart(res.data.responseObject);
    return res;
  }
  const addPurchaseCategory = async () => {
    const res = await hubbleClient.checkout.addPurchaseCategory(getCartID.value);
    updateCart(res.data.responseObject);
    return res;
  }
  const setCustomerType = (type) => {
    appContext.$storage.setLocalStorage('tlmCustomerType', type);
  }
  const getCustomerType = () => {
    return appContext.$storage.getLocalStorage('tlmCustomerType');
  }
  const setCVRNumberInStorage = (cvrNumber) => {
    appContext.$storage.setLocalStorage('tlmCvr', cvrNumber);
  }
  const getCVRNumberInStorage = () => {
    return appContext.$storage.getLocalStorage('tlmCvr');
  }
  const setCustomerInfoInStorage = (info) => {
    appContext.$storage.setLocalStorage('tlmCustomerInfo', info);
  }
  const getCustomerInfoInStorage = () => {
    return appContext.$storage.getLocalStorage('tlmCustomerInfo')
  }
  return {
    setCustomerInfoInStorage,
    getCustomerInfoInStorage,
    setCVRNumberInStorage,
    getCVRNumberInStorage,
    getCustomerType,
    setCustomerType,
    addPhoneNumberAndEmailToAddress,
    addPurchaseCategory,
    addPrepaidEmail,
    addPhoneNumberToAddress,
    removeNumberInfo,
    removeInstallmentFromCart,
    addNumberInfo,
    addPermissionInformation,
    addChangeSubscriptionCustomerInfo,
    removeChangeSubscriptionCustomerInfo
  }
}
